import React, { useEffect, useState } from 'react';
import WOW from "wowjs";
import { Link } from 'react-router-dom';

function ServiceFour() {  
  useEffect(() => {
    const wow = new WOW.WOW({
      live: false, // This disables continuous scanning for new elements
    });
    wow.init();
  }, []);

  const [readMore, setReadMore] = useState({}); // Track read-more state for each service

  const toggleReadMore = (index) => {
    setReadMore((prevState) => ({
      ...prevState,
      [index]: !prevState[index], // Toggle the specific service
    }));
  };

  const services = [
    {
      icon: "assets/images/services/s1.png",
      title: "Professional Networking",
      description:
        "V2V brings together professionals from various industries, creating a space for collaboration, knowledge exchange, and business growth. Whether you're seeking new partners, clients, or experts in your field, our network provides meaningful connections to help you thrive.",
      shortDescription:
        "V2V brings together professionals from various industries, creating a space for collaboration...",
    },
    {
      icon: "assets/images/services/s2.png",
      title: "Business Resources and Learning",
      description:
        "Members have exclusive access to a variety of resources, such as articles, webinars, eBooks, tools, and courses that focus on business development, innovation, and leadership. We believe ongoing education is essential for success, and we offer the resources you need to stay ahead in an ever-changing business landscape.",
      shortDescription:
        "Members have exclusive access to a variety of resources, such as articles and webinars...",
    },
    {
      icon: "assets/images/services/s3.png",
      title: "Events and Webinars",
      description:
        "We organize both virtual and in-person events, including networking sessions, industry discussions, and expert-led webinars. These gatherings provide opportunities to learn from leaders, exchange ideas, and collaborate on exciting projects. Engage in discussions that influence the future of business!",
      shortDescription:
        "We organize both virtual and in-person events, including networking sessions...",
    },
    // {
    //   icon: "assets/images/services/agency-3.svg",
    //   title: "Job Opportunities and Talent Pool",
    //   description:
    //     "As a member, you’ll have access to job listings, talent search services, and business prospects within the network. Whether you're recruiting or seeking new career opportunities, the V2V Business Network is the ideal place to take the next step in your professional journey.",
    //   shortDescription:
    //     "As a member, you’ll have access to job listings, talent search services...",
    // },
  ];

  return (
    <div>
      <div className="best-service-we-provide pt--60 tmp-section-gapBottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-head">
                <div className="section-sub-title center-title">
                  <img
                    src="assets/images/services/section-custom-menubar.png"
                    alt="Business_Consulting_services"
                  />
                  <span> Services </span>
                </div>
                <h2 className="title split-collab">What We Do ?</h2>
              </div>
            </div>
          </div>
          <div className="row g-5">
            {services.map((service, index) => (
              <div
                key={index}
                className="col-lg-4 col-md-4 col-sm-6 col-12 wow fadeInUp"
                data-wow-duration=".8s"
                data-wow-delay={`${0.1 * (index + 1)}s`}
              >
                <div className="service-inner financial-service-inner agency-service feature-service">
                  <div className="icon">
                    <img src={service.icon} alt={service.title} />
                  </div>
                  <div className="content">
                    <h2 className="title">{service.title}</h2>
                    <p className="description">
                      {readMore[index]
                        ? service.description
                        : service.shortDescription}
                    </p>
                    <button
                      onClick={() => toggleReadMore(index)}
                      className="read-more-btn"
                      style={{
                        border: "none",
                        background: "transparent",
                        color: "#007bff",
                        cursor: "pointer",
                        padding: "0",
                        marginTop: "10px",
                        fontSize:"18px"
                      }}
                    >
                      {readMore[index] ? "Read Less" : "Read More"}
                    </button>
                  </div>
                  
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceFour;
